import { useState, useEffect } from 'react';

/**
 * useMediaQuery
 * Returns true when the given CSS media query matches.
 * Safe for SSR (returns false on the server).
 *
 * Usage:
 *   const isMobile = useMediaQuery('(max-width: 767px)');
 */
export function useMediaQuery(query) {
  const getMatches = () =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false;

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);

    mql.addEventListener('change', handler);
    // Re-sync in case the value changed between render and effect
    setMatches(mql.matches);

    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return matches;
}